import axios from 'axios';
import { API_BASE_URL } from '../constants/index';
import { tokenStore, refreshSessionOnce } from './core';

// Cliente do backend do Task (domínio: tarefas/projetos/horas...). A identidade
// é do Core: anexamos o access token do Core + a empresa ativa (X-Company-Id).
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const access = tokenStore.getAccess();
  if (access) {
    config.headers.Authorization = `Bearer ${access}`;
  }
  const companyId = tokenStore.getCompanyId();
  if (companyId) {
    config.headers['X-Company-Id'] = companyId;
  }
  return config;
});

// Refresh-then-retry em 401 (single-flight compartilhado). Falha terminal → /login.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;

    if (status === 401 && !original._retry) {
      original._retry = true;
      try {
        const data = await refreshSessionOnce();
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (_e) {
        tokenStore.clear();
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
